import { render } from "./refundDetail.vue?vue&type=template&id=6086ae38&scoped=true"
import script from "./refundDetail.vue?vue&type=script&lang=js"
export * from "./refundDetail.vue?vue&type=script&lang=js"

import "./refundDetail.vue?vue&type=style&index=0&id=6086ae38&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6086ae38"]])

export default __exports__